// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:17
import { EventQuestionDefinition_abstract } from './../abstract/SagaSchema/EventQuestionDefinition_abstract';
export class EventQuestionDefinition extends EventQuestionDefinition_abstract {}
